import Swal from 'sweetalert2';
import cookie from 'react-cookies';
import axios from 'axios';
import { permissionTypes } from 'drapcode-constant';
import { Mixpanel } from '../../common/utils/mixpanelUtil';
const alertOptions = {
  allowOutsideClick: false,
  allowEscapeKey: false,
  allowEnterKey: false,
  icon: 'error',
  title: 'Oops...',
};

export const checkAndValidateProject = async (projectId, version, actions) => {
  let token = '';
  if (cookie.load('token')) {
    token = cookie.load('token');
  } else {
    console.log('window.location :>> ', window.location);
    console.log('window :>> ', window);
    let searchParams = new URLSearchParams(window.location.search);
    token = searchParams.get('token');
  }
  let config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
  const projectUrl = `${process.env.REACT_APP_ORGANIZATION_ENGINE}clients/details/${projectId}/project`;
  console.log('projectUrl :>> ', projectUrl);
  console.log('config :>> ', config);
  try {
    const response = await axios.get(projectUrl, config);
    let { status, message, user, organization, role } = response.data;
    if (status === 'FAILED') {
      resetCookie();
      Swal.fire({
        ...alertOptions,
        text: message,
        confirmButtonText: 'Try Again',
        footer: `<a href="${process.env.REACT_APP_ORGANIZATION}contact-us">Why do I have this issue?</a>`,
      }).then((result) => {
        if (result.isConfirmed) {
          window.location.href = `${process.env.REACT_APP_ORGANIZATION}`;
        }
      });
      return { showLoader: false, showContent: false };
    } else if (status === 'SUCCESS') {
      // actions.loadProjectDetail({ projectId, version });
      if (role === 'ROLE_ADMIN') {
        organization = { permissions: permissionTypes, subscription: 'UNLIMITED' };
      }
      await setCookie(user, organization);
      return { showLoader: false, showContent: true };
    }
  } catch (err) {
    resetCookie();
    console.log('err :>> ', err);
    if (err && err.response && err.response.status === 401) {
      Swal.fire({
        ...alertOptions,
        text: 'Your have been logged out due to inactivity. Please login again.',
        confirmButtonText: 'Login',
      }).then((result) => {
        if (result.isConfirmed) {
          window.location.href = `${process.env.REACT_APP_ORGANIZATION}`;
        }
      });
    }
    window.location.href = `${process.env.REACT_APP_ORGANIZATION}`;
    return { showLoader: false, showContent: true };
  }
};

const setCookie = async (user, organization) => {
  const { authorities, username, displayName, uuid } = user;
  const expires = new Date();
  expires.setDate(Date.now() + 1000 * 60 * 60 * 24);
  cookie.save('username', username, { path: '/', expires });
  cookie.save('uuid', uuid, { path: '/', expires });
  cookie.save('role', authorities[0], { path: '/', expires });
  cookie.save('isLoggedIn', true, { path: '/', expires });
  cookie.save('name', displayName, { path: '/', expires });

  //Save Organization Detail
  cookie.save('permissions', organization.permissions, { path: '/', expires });
  cookie.save('subscription', organization.subscription, { path: '/', expires });
  Mixpanel.identify(username);
  Mixpanel.track('Open Builder');
};

const resetCookie = () => {
  Mixpanel.track('Logged Out from Builder');
  Mixpanel.reset();
  cookie.remove('username', { path: '/' });
  cookie.remove('uuid', { path: '/' });
  cookie.remove('isLoggedIn', { path: '/' });
  cookie.remove('token', { path: '/' });
  cookie.remove('role', { path: '/' });
  cookie.remove('name', { path: '/' });
  cookie.remove('permissions', { path: '/' });
  cookie.remove('subscription', { path: '/' });
};

export const updateUserIpInCookie = async () => {
  try {
    const expires = new Date(Date.now() + 86400000);
    const apiData = await axios.get(`https://api.ipify.org/?format=json`);
    const publicIp = apiData.data.ip;
    cookie.save('userIp', publicIp, { expires });
    return publicIp;
  } catch (error) {
    console.error('An error occurred:', error);
    return null;
  }
};

export const checkPageSnapPermission = () => {
  return checkPermission(permissionTypes.PAGE_SNAPSHOTS);
};
export const checkSnippetSnapPermission = () => {
  return checkPermission(permissionTypes.SNIPPET_SNAPSHOTS);
};
const checkPermission = (code) => {
  const subscription = loadOrganizationDetails('subscription');
  if (subscription === 'UNLIMITED') return true;
  const permissions = loadOrganizationDetails('permissions');
  if (!permissions) {
    return true;
  }
  return permissions.includes(code);
};
export const loadOrganizationDetails = (key) => {
  return cookie.load(key);
};
